export default {
    turn : {
        account: "Tài Khoản Hội Viên",
        count: "Số lần Thừa Ra",
        history: "Ký Lục Rút Thưởng",
        time: "Thời Gian Rút Thưởng",
        EventsTime: "Thời Gian Hoạt Động",
        EventsActivities: "Nội Dung Hoạt Động",
        to: "Đến",
        prize: "Trúng Thưởng Giải Thưởng",
        status: "Trạng Thái Phát Thưởng",
        unpay:  "Chưa Phân Phát",
        payed:  "Đã Phân Phát",
        accountError: "Tài Khoản Bất Thường",
        contact: "Xin Liên Hệ Dịch Vụ Khách Hàng Trực Tuyến",
        zero: "Số Lần Rút Thưởng là 0",
        drawing: "Đang Trong Quá Trình Rút Thưởng.",
        congratulations: "Chúc Mừng Bạn Đã Nhận Được",
        activityEnds: 'Hoạt Động Đã Kết Thúc',
        EndlookIt: 'Xin Hãy Chờ Hoạt Động Lần Sau',
        activityStart: 'Hoạt Động Sẽ Bắt Đầu',
        EventsNotStart: 'Hoạt Động Này Vẫn Chưa Khai Mở',
        UnderConstruction: 'Hoạt Động Đang Trong Quá Trình Xây Dựng',
        StartlookIt: 'Kính Xin Chờ Đợi',
        EventsisEnd: 'Hoạt Động Này Đã Kết Thúc',
        ThanksJoin: 'Cảm Ơn Sự Tham Gia Của Bạn',
        AccountError: 'Tài Khoản Bất Thường',
        DataError: 'Dữ Liệu Bị Lỗi',
        TokenError: 'Lỗi Xác Thực Mã Thông Báo',
        drawCountEmpty: 'Số Lần Rút Thưởng Không Đủ'

    },
    awards: {
        "0": "1st",
        "1": "2nd",
        "2": "3rd",
        "3": "4th",
        "4": "5th",
        "5": "6th",
        "6": "7th",
        "7": "8th",
        "8": "9th",
        "9": "10th"
    },
    login: {
        title: 'Lucky Draw Station',
        logIn: 'Sign in',
        account: 'Account',
        password: 'Password'
    },

    navbar: {
        switchLang: "Language",
        home: 'Home',
        profile: 'Profile',
        logOut: 'Log Out',
        message: {
            hello: 'Hi, {msg}'
        }
    },

    level: {
        levelId:  "No. Pool",
        totalBet: "Total Rolloer"
    },
    award: {
        awards: "Phần thưởng",
        rate:   "Winning Odds",
        level:  "Pool "
    },
    awardLimit: {
        award:     "Phần thưởng",
        remaining: "Remain Prizes",
        limit:     "Total Prize",
        unlimit:   "Unlimited"
    },
    userInfo: {
        all:        "Toàn Bộ",
        platform:   "Nền Tảng",
        account:    "Tài Khoản Hội Viên",
        count:      "Số Lần Có Thể Rút Thưởng",
        totalCount: "Tổng Số Lần Rút Thưởng",
        totalBet:   "Tổng Doanh Số",
        level:      "Hạn mức "
    },
    winningRecord: {
        all:          "Toàn Bộ",
        account:      "Tài Khoản Hội Viên",
        winningTime:  "Thời Gian Trúng Thưởng",
        platform:     "Nền Tảng",
        award:        "Phần thưởng",
        status:       "Trạng Thái Phát Thưởng",
        action:       "Vận hành",
        unpay:        "Chưa Phân Phát ",
        payed:        "Claimed",
        pay:          "Phân Phát",
        previousPage: "Trang  Phía Trước",
        nextPage: "Trang Tiếp Theo",
        page: "Trang {page}",
    },

    button: {
        search: "Tìm Kiếm"

    },

    status: {
        update: {
            success: "Tìm Kiếm Thành Công",
            error: "Tìm Kiếm Thất Bại",
        }
    },

   router: {
        level: "Rollover Setting",
        award: "Phần thưởng",
        awardLimit: "Prizes",
        userInfo: "Winner Record",
        winningRecord: "Prizes Record",
        dashboard: "Home"
    },

    //擴充自定義原element-ui的設定名稱
    elementUI: {
        datepicker: {
            rangeSeparator: "To",
            startMonth: "StartMonth",
            endMonth: "EndMonth",
        },
        confirm :{
            check: "Are you sure to claim?",
            tips: "Hint",
            confirm: "Confirm",
            cancel: "Cancel",
            canceled: "Cancelled",
        }
    },

    validator: {
        required: "Required",
    },
}



// WEBPACK FOOTER //
// ./src/lang/vi.js